import MyContext from "../../../../contexts/MyContext";
import { TicketForm3New } from "../ticket-forms/TicketForm3New";
export const Slide3New = (props) => {
  return (
    <MyContext.Consumer>
      {(context) => (
        <div hidden={context.activeSlide !== 2}>
          <TicketForm3New {...props} />
        </div>
      )}
    </MyContext.Consumer>
  );
};
